// Module
var code = `<aside ng-if="\$ctrl.items && \$ctrl.items.length > 0" class="list-none bg-main-field"> <sidebar-item ng-repeat="item in \$ctrl.items track by item.id" item="item" selected-item-id="\$ctrl.selectedItemId" ng-if="item.enabled !== false" on-click="\$ctrl.handleTabChange(\$tab)"></sidebar-item> </aside>`;
// Exports
export default code;